import { render, staticRenderFns } from "./directbox-default.vue?vue&type=template&id=31f257b6&"
import script from "./directbox-default.vue?vue&type=script&lang=js&"
export * from "./directbox-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f257b6')) {
      api.createRecord('31f257b6', component.options)
    } else {
      api.reload('31f257b6', component.options)
    }
    module.hot.accept("./directbox-default.vue?vue&type=template&id=31f257b6&", function () {
      api.rerender('31f257b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/directbox-default.vue"
export default component.exports